import { ConnectedRouter } from 'connected-react-router';
import { b64DecodeUnicode } from "environment";
import createHistory from "history/createBrowserHistory";
import * as React from "react";
import * as ReactModal from "react-modal";
import { Provider } from "react-redux";
import ReduxToastr from "react-redux-toastr";
import { Route } from "react-router-dom";
import { Layout } from "./components/Layout";
import { configureStore } from "./store/configure";

const history = createHistory();
let initialState = undefined;
if (window["__defaultState"]) {
    // Parse the state from the base64 encoding
    initialState = JSON.parse(b64DecodeUnicode(window["__defaultState"]));
}

// Get the application-wide store instance, prepopulating with state from the server where available.
const store = configureStore(history, initialState);

export const App = () => (
    <Provider store={store}>
        <div>
            <ConnectedRouter history={history}>
                <div>
                    <Route path="/" component={Layout} />
                </div>
            </ConnectedRouter>
            <ReduxToastr />
        </div>
    </Provider>
);


ReactModal.setAppElement("#root");
